<div class="investment-amount-type">
  <p class="title ds-heading-1 ds-color-core-neutral-10">{{ 'GROW.project.investmentFlow.step1.heading' | translate }}</p>
  <app-ds-radio-option
    [value]="amountType.RECOMMENDED"
    [selected]="selectedType"
    (clicked)="onOptionChange($event)"
    [disabled]="!hasRecommendedAmount"
  >
    <ng-container ds-radio-title>
      {{ 'GROW.project.investmentFlow.step1.investmentOptions.' + (hasRecommendedAmount ? 'recommended' : 'recommendedNotAvailable') | translate }}
    </ng-container>
  </app-ds-radio-option>
  <div class="not-available-callout" *ngIf="!hasRecommendedAmount">
    <app-ds-callout
      variant="info"
      [description]="
        'GROW.project.investmentFlow.step1.callout.recommendedNotAvailable.' +
          (project.account_specific.recommended_additional_amount === 0 ? 'overRecommended' : 'body') | translate
      "
    ></app-ds-callout>
  </div>

  <div class="ds-rows-white" *ngIf="selectedType === amountType.RECOMMENDED">
    <div class="ds-row-white only-one-row">
      <div class="amount-with-info">
        <p class="ds-heading-1 ds-color-core-neutral-10">
          {{ project.account_specific.recommended_additional_amount | thousand: project.currency }}
          <span class="ds-ui-2 ds-color-core-neutral-5" *ngIf="project.currency.toLowerCase() !== growAccount.currency.toLowerCase()">
            (&#126;{{
              project.account_specific.recommended_additional_amount * growAccount.eur_exchange_rate | thousand: growAccount.currency : false : 2
            }})
          </span>
        </p>
        <div>
          <ion-icon name="info2" (click)="onToggleInfo()"></ion-icon>
        </div>
      </div>
      <div class="ds-ui-3 ds-color-core-neutral-7 row-info" *ngIf="showAmountInfo">
        {{
          'GROW.project.investmentFlow.step1.recommendedAmount.infoText'
            | translate
              : {
                  riskLevel: 'GROW.performance.strategy.portfolio.riskProfile.' + riskLevel | translate,
                  selectedRisk: growAccount.stock_split | percent: '1.0',
                  portfolioValueProjectCurrency: project.account_specific.portfolio_value_in_project_currency | thousand: project.currency,
                  projectsValueProjectCurrency: project.account_specific.projects_value_in_project_currency | thousand: project.currency,
                  recommendedAmount: project.account_specific.recommended_additional_amount | thousand: project.currency
                }
        }}
        <ng-container *ngIf="project.currency !== growAccount.currency">
          {{ 'GROW.project.currency.exchangeNotice' | translate }}
        </ng-container>
      </div>
    </div>
  </div>
  <app-ds-radio-option [value]="amountType.CUSTOM" [selected]="selectedType" (clicked)="onOptionChange($event)">
    <ng-container ds-radio-title>{{ 'GROW.project.investmentFlow.step1.investmentOptions.personalised' | translate }}</ng-container>
  </app-ds-radio-option>
</div>

<form class="customer-amount-form" [formGroup]="amountForm" #form="ngForm" (ngSubmit)="onSubmit()">
  <div
    *ngIf="selectedType === amountType.CUSTOM"
    class="ds-form-row"
    [ngClass]="{
      'has-error': (amountControl.dirty && amountControl.invalid) || (form.submitted && amountControl.invalid),
      'has-helper': project.currency.toLowerCase() !== growAccount.currency.toLowerCase() && amountControl.valid
    }"
  >
    <label class="ds-label">{{ 'GROW.project.investmentFlow.step1.customAmount.label' | translate: { currency: project.currency } }}</label>

    <input *ngIf="amountEditMode" appAutoFocus formControlName="amount" class="ds-input" type="number" (blur)="amountEditMode = false" />
    <input
      *ngIf="!amountEditMode"
      class="ds-input"
      readonly
      type="text"
      [value]="!amountControl.value ? '' : (amountControl.value | thousand)"
      [placeholder]="(hasRecommendedAmount ? project.account_specific.recommended_additional_amount : '') | thousand"
      (focus)="amountEditMode = true"
    />

    <div *ngIf="project.currency.toLowerCase() !== growAccount.currency.toLowerCase() && amountControl.valid" class="ds-input-helper">
      &#126;{{ amountControl.value * growAccount.eur_exchange_rate | thousand: growAccount.currency }}
    </div>

    <div *ngIf="(amountControl.dirty && amountControl.invalid) || (form.submitted && amountControl.invalid)" class="ds-input-error">
      <ng-container *ngIf="amountControl.hasError('required')">{{ 'GROW.riskProfile.profile.errors.required' | translate }}</ng-container>

      <ng-container *ngIf="!amountControl.hasError('required') && amountControl.hasError('min')">
        {{ 'GROW.project.investmentFlow.step1.customAmount.minAmountError' | translate: { minimumInvestment: project.minimum_funding } }}
      </ng-container>

      <ng-container *ngIf="amountControl.hasError('max')">
        {{
          'GROW.project.investmentFlow.step1.customAmount.maxAmountError'
            | translate: { maximumInvestment: project.account_specific.maximum_additional_amount }
        }}
      </ng-container>

      <ng-container
        *ngIf="
          !amountControl.hasError('required') &&
          !amountControl.hasError('min') &&
          !amountControl.hasError('max') &&
          amountControl.hasError('incrementError')
        "
      >
        {{
          'GROW.project.investmentFlow.step1.customAmount.incrementError'
            | translate
              : {
                  incrementSize: project.increment_step,
                  amountExample: project.account_specific.recommended_additional_amount + project.increment_step
                }
        }}
      </ng-container>
    </div>

    <div class="investment-hints">
      <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.project.investmentFlow.step1.customAmount.requirements.label' | translate }}</p>
      <ul class="ds-color-core-neutral-7 ds-ui-3">
        <li
          [innerHTML]="
            'GROW.project.investmentFlow.step1.customAmount.requirements.minimum'
              | translate: { minimumInvestment: project.minimum_funding | thousand: project.currency }
          "
        ></li>
        <li
          [innerHTML]="
            'GROW.project.investmentFlow.step1.customAmount.requirements.maximum'
              | translate: { maximumInvestment: project.account_specific.maximum_additional_amount | thousand: project.currency }
          "
        ></li>
        <li
          [innerHTML]="
            'GROW.project.investmentFlow.step1.customAmount.requirements.incrementSize'
              | translate: { incrementSize: project.increment_step | thousand: project.currency }
          "
        ></li>
      </ul>
      <p class="ds-ui-3 ds-color-core-neutral-7" *ngIf="project.currency.toLowerCase() !== growAccount.currency.toLowerCase()">
        {{ 'GROW.project.currency.exchangeNotice' | translate }}
      </p>
    </div>
    <div class="review-box" [class.has-error]="form.submitted && riskAgreedControl.invalid">
      <app-ds-checkbox
        formControlName="riskAgreed"
        [checkboxPosition]="'top'"
        [label]="
          isCustomAmountCausingClusterRisk
            ? ('GROW.project.investmentFlow.step1.personalisedConsent.body' | translate) +
              ' ' +
              ('GROW.project.investmentFlow.step1.personalisedConsent.clusterRiskBody'
                | translate: { percentageOfPortfolio: (percentageOfPortfolio | percent: '1.0-1') })
            : ('GROW.project.investmentFlow.step1.personalisedConsent.body' | translate)
        "
        [checked]="riskAgreedControl.value"
        [hasError]="form.submitted && riskAgreedControl.invalid"
        (clicked)="onAccept()"
        [errorMessage]="'GROW.project.investmentFlow.step1.personalisedConsent.missingError' | translate"
      ></app-ds-checkbox>
    </div>
  </div>

  <app-ds-button type="submit">{{ 'GROW.project.investmentFlow.step1.buttonLabel' | translate }}</app-ds-button>
  <p class="ds-ui-3 ds-color-core-neutral-7 disclaimer">
    {{ 'GROW.project.investmentFlow.step1.disclaimer' | translate: { cashPercentage: project.cash_percentage | percent: '1.2' } }}
  </p>
</form>
